import {
    CLEAR_ENTITY_SENSOR_DATA,
    CLEAR_SELECTED_NAV_CLIENT,
    CLEAR_SELECTED_NAV_SITE,
    CLEAR_SELECTED_NAV_EQUIPMENT,
    CLEAR_SELECTED_NAV_SYSTEM,
    FETCH_ENTITY_SENSORS_TABLE,
    FETCH_EQUIPMENT_RULES,
    FETCH_FAULT_HISTORY,
    FETCH_FAULT_OVERLAY,
    FETCH_FAULT_SUMMARY,
    FETCH_NAV_CLIENTS,
    FETCH_NAV_EQUIPMENT,
    FETCH_NAV_SITES,
    FETCH_NAV_SYSTEMS,
    FETCH_SCORING_DATA,
    SET_ACTIVE_NAV_CLIENT,
    SET_ACTIVE_NAV_COMPANY,
    SET_ACTIVE_NAV_SITE,
    SET_ACTIVE_NAV_EQUIPMENT,
    SET_ALL_SENSORS,
    SET_BOB_LOADING,
    SET_CONFIG_SENSORS,
    SET_COMPANY_APPLICATIONS,
    SET_ENTITY_RULES,
    SET_ENTITY_SENSOR_DATA,
    SET_ENTITY_SENSORS,
    SET_ENTITY_SCORES_DATA,
    SET_ENTITY_SCORING_DATA,
    SET_FAULT_DATA,
    SET_NAV_CLIENT,
    SET_NAV_COMPANY,
    SET_NAV_SITE,
    SET_NAV_EQUIPMENT,
    SET_NAV_SYSTEM
} from '../actions/actionTypes';

const initialState = {
    activeNavCompany:      {},
    activeNavClient:       {},
    activeNavSite:         {},
    activeNavEquipment:    {},
    allSensors:            [],
    allSensorsMeta:        {},
    bobLoading:            [],
    configSensors:         [],
    companyApplications:   [],
    entitySensorData:      [],
    entityScoresData:      [],
    entityScoringData:     [],
    entityScoringDataMeta: {},
    entityRules:           [],
    entityRulesMeta:       {},
    faultData:             [],
    faultHistory:          [],
    faultHistoryMeta:      {},
    faultOverlay:          [],
    faultSummary:          [],
    faultSummaryMeta:      {},
    navClients:            [],
    navClientsMeta:        {},
    navEquipment:          [],
    navEquipmentMeta:      {},
    navSites:              [],
    navSitesMeta:          {},
    navSystems:            [],
    navSystemsMeta:        {},
    sensors:               [],
    sensorsMeta:           {},
    targetNavCompany:      {},
    targetNavClient:       {},
    targetNavSite:         {},
    targetNavEquipment:    {},
    targetNavSystem:       {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case CLEAR_ENTITY_SENSOR_DATA:
            return {
                ...state,
                entitySensorData: []
            };
        case FETCH_FAULT_HISTORY:
            return {
                ...state,
                faultHistory:     [...action.payload.data],
                faultHistoryMeta: { ...action.payload.meta }
            };
        case FETCH_FAULT_OVERLAY:
            return {
                ...state,
                faultOverlay: [ ...action.payload ]
            };
        case FETCH_FAULT_SUMMARY:
            return {
                ...state,
                faultSummary:     [...action.payload.data],
                faultSummaryMeta: { ...action.payload.meta }
            };
        case FETCH_ENTITY_SENSORS_TABLE:
            return {
                ...state,
                sensors:     [ ...action.payload.sensors ],
                sensorsMeta: { ...action.payload.meta }
            };
        case FETCH_NAV_CLIENTS:
            return {
                ...state,
                navClients:     [...action.payload.clients],
                navClientsMeta: {...action.payload.meta}
            };
        case FETCH_NAV_EQUIPMENT:
            return {
                ...state,
                navEquipment:     [...action.payload.equipment],
                navEquipmentMeta: {...action.payload.meta}
            };
        case FETCH_NAV_SITES:
            return {
                ...state,
                navSites:     [...action.payload.sites],
                navSitesMeta: {...action.payload.meta}
            };
        case FETCH_NAV_SYSTEMS:
            return {
                ...state,
                navSystems:     [...action.payload.system],
                navSystemsMeta: {...action.payload.meta}
            };
        case FETCH_SCORING_DATA:
            return {
                ...state,
                entityScoringData:     [...action.payload.data],
                entityScoringDataMeta: {...action.payload.meta}
            };
        case SET_ACTIVE_NAV_CLIENT:
            return {
                ...state,
                activeNavClient: {...action.payload}
            };
        case SET_ACTIVE_NAV_COMPANY:
            return {
                ...state,
                activeNavCompany: {...action.payload}
            };
        case SET_ACTIVE_NAV_SITE:
            return {
                ...state,
                activeNavSite: {...action.payload}
            };
        case SET_ACTIVE_NAV_EQUIPMENT:
            return {
                ...state,
                activeNavEquipment: {...action.payload}
            };
        case SET_ALL_SENSORS:
            return {
                ...state,
                allSensors:     [...action.payload.sensors],
                allSensorsMeta: { ...action.payload.meta }
            };
        case SET_BOB_LOADING:
            return {
                ...state,
                bobLoading: [...action.payload]
            };
        case SET_CONFIG_SENSORS:
            return {
                ...state,
                configSensors: [...action.payload]
            };
        case SET_COMPANY_APPLICATIONS:
            return {
                ...state,
                companyApplications: [...action.payload]
            };
        case SET_ENTITY_SENSOR_DATA:
            return {
                ...state,
                entitySensorData: [...action.payload]
            };
        case SET_ENTITY_SENSORS:
            return {
                ...state,
                sensors:     [...action.payload.sensors],
                sensorsMeta: {...action.payload.meta}
            };
        case SET_NAV_CLIENT:
            return {
                ...state,
                targetNavClient: {...action.payload}
            };
        case SET_NAV_COMPANY:
            return {
                ...state,
                targetNavCompany: {...action.payload}
            };
        case SET_NAV_SITE:
            return {
                ...state,
                targetNavSite: {...action.payload}
            };
        case SET_NAV_EQUIPMENT:
            return {
                ...state,
                targetNavEquipment: {...action.payload}
            };
        case SET_NAV_SYSTEM:
            return {
                ...state,
                targetNavSystem: {...action.payload}
            };
        case FETCH_EQUIPMENT_RULES:
            return {
                ...state,
                entityRules:     [...action.payload.faults],
                entityRulesMeta: {...action.payload.meta}
            };
        case SET_ENTITY_RULES:
            return {
                ...state,
                entityRules:     [...action.payload.data],
                entityRulesMeta: {...action.payload.meta}
            };
        case SET_ENTITY_SCORES_DATA:
            return {
                ...state,
                entityScoresData: [...action.payload]
            };
        case SET_ENTITY_SCORING_DATA:
            return {
                ...state,
                entityScoringData:     [...action.payload.data],
                entityScoringDataMeta: {...action.payload.meta}
            };
        case SET_FAULT_DATA:
            return {
                ...state,
                faultData: action.payload
            };
        case CLEAR_SELECTED_NAV_CLIENT :
            return {
                ...state,
                targetNavClient:    {},
                targetNavSite:      {},
                targetNavEquipment: {},
                targetNavSystem:    {},
                navEquipment:       [],
                navEquipmentMeta:   {},
                navSites:           [],
                navSitesMeta:       {},
                navSystems:         [],
                navSystemsMeta:     {}
            }; 
        case CLEAR_SELECTED_NAV_SITE:
            return {
                ...state,
                targetNavSite:      {},
                targetNavEquipment: {},
                targetNavSystem:    {},
                navEquipment:       [],
                navEquipmentMeta:   {},
                navSystems:         [],
                navSystemsMeta:     {}
            };
        case CLEAR_SELECTED_NAV_EQUIPMENT :
            return {
                ...state,
                targetNavEquipment: {}
            };
        case CLEAR_SELECTED_NAV_SYSTEM :
            return {
                ...state,
                targetNavSystem: {},
            };
        default:
            return state;
    }
};
